import { TestingImpersonationTableEntity } from "@pages/testing-impersonation/testing-impersonation-table-types";
import { AppEnv } from "@src/runtime-config-types";

/** The data to be tested */
export const testingImpersonationEntries: Record<
  AppEnv,
  TestingImpersonationTableEntity[]
> = {
  ["com-dev"]: [
    {
      memberId: "918d62f2-58ba-42b5-913a-0fa5bfb06dd4",
      name: "Stellar Enterprise Viewer",
      email: "faro-team-stellar+enterprise_viewer@ametek.com",
      description: "Has access to the Enterprise Viewer role",
    },
  ],
  ["com-staging"]: [],
  ["eu-dev"]: [],
  ["eu-staging"]: [],
  ["com-production"]: [],
  ["eu-production"]: [],
};
